// extracted by mini-css-extract-plugin
export default {"fullContent":"sign-up_fullContent__6xJay","elements":"sign-up_elements__hxHEg","loginText":"sign-up_loginText__AJE7B","marginTop":"sign-up_marginTop__E-dK5"};